import { Container, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { AppContext } from '../../../context/AppContext';
import PerfilForm from '../../forms/Perfil';

export const PerfilPage = () => {
	return (
		<div>
			<Container maxWidth="lg" align="center" style={{ marginTop: '5%' }}>
				<Typography variant="h5">Datos del aspirante</Typography>
				<PerfilForm />
			</Container>
		</div>
	);
};
